import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAMetaDataThemeNameText({name}) {
    // Used in LevelAMetaData to display LevelA Theme name

    // BUILD
    if (isNullOrUndefined(name))
        return null
    return (
        <div className={"flex justify-start items-center space-x-[4px]"}>
            <span className={""}>
                {"• "}
            </span>
            <span className={"px-[2px]"}>
                {name}
            </span>
        </div>
    );
}